import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./css/viewpost.css";

function ViewPost() {
  const { id } = useParams(); // Get the post ID from the URL
  const [post, setPost] = useState(null);

  useEffect(() => {
    const savedPosts = JSON.parse(localStorage.getItem("posts")) || [];
    const selectedPost = savedPosts[id];
    setPost(selectedPost);
  }, [id]);

  if (!post) {
    return <p>المقال غير موجود</p>;
  }

  return (
    <div className="view-post-container">
      <h1>{post.title}</h1>
      <p>تاريخ: {post.date}</p>
      {post.image && <img src={post.image} alt="Blog Post" />}
      <p>{post.content}</p>
      {post.video && (
        <iframe
          width="560"
          height="315"
          src={post.video.replace("watch?v=", "embed/")}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={post.title}
        ></iframe>
      )}
    </div>
  );
}
export default ViewPost;



